export enum NotificationMutationTypes {
  SET_UNREAD_COUNT = 'SET_UNREAD_COUNT',
  INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT'
}